// extracted by mini-css-extract-plugin
module.exports = {"menu":"index-module--menu--21nQJ","logo":"index-module--logo--23i-W"};